function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Somos1DataEntryService from '@/apps/customer-insigths/services/somos1_data_entry_service';
import Somos1DataEntryBulkUpload from '@/apps/customer-insigths/components/Somos1DataEntryBulkUpload';
import Somos1BudgetUpload from '@/apps/customer-insigths/components/Somos1BudgetUpload';
import StateComponent from '@/components/StateComponent.vue';
import { mapState } from "vuex";
import Somos1ForecastUpload from "@/apps/customer-insigths/components/Somos1ForecastUpload.vue";
export default {
  name: 'Somos1DataEntry',
  components: {
    Somos1ForecastUpload: Somos1ForecastUpload,
    Somos1DataEntryBulkUpload: Somos1DataEntryBulkUpload,
    Somos1BudgetUpload: Somos1BudgetUpload,
    StateComponent: StateComponent
  },
  data: function data() {
    var _this = this;
    return {
      disabled: false,
      disabledBudget: false,
      disabledForecast: false,
      valid: true,
      loading: false,
      loading_log: false,
      INTERCORP_COMPANY_CODE: '032',
      INLEARNING_DOMAIN: 'inlearning.pe',
      INRETAILPHARMA_DOMAIN: 'inretailpharma.com',
      DIALOG_DATA_ENTRY_UPLOAD: 'DIALOG_DATA_ENTRY_UPLOAD',
      DIALOG_DATA_ENTRY_UPLOAD_BUDGET: 'DIALOG_DATA_ENTRY_UPLOAD_BUDGET',
      DIALOG_DATA_ENTRY_UPLOAD_FORECAST: 'DIALOG_DATA_ENTRY_UPLOAD_FORECAST',
      items: [],
      tipo_reporte_id: 1,
      tipoReporteList: [{
        id: 1,
        name: 'Indicadores mensuales'
      }, {
        id: 2,
        name: 'Presupuesto'
      }, {
        id: 3,
        name: 'Forecast 3+9'
      }, {
        id: 4,
        name: 'Forecast 6+6'
      }, {
        id: 5,
        name: 'Forecast 9+3'
      }],
      organization_id: 0,
      organizationsList: [],
      brand_id: 0,
      brandsList: [],
      indicator_id: 0,
      indicatorsList: [],
      region_id: 0,
      regionsList: [],
      filter_enabled: false,
      filtro: {
        isGeneral: false
      },
      format_cells: 2,
      canUpload: false,
      isAdmin: false,
      data: [],
      columns: {
        'Año': 'year',
        'Mes': 'month',
        'Empresa': 'organization',
        'Marca': 'brand',
        'Región': 'region',
        'Indicador': 'indicator',
        'Valor': 'value'
      },
      rules: {
        organization: [function (v) {
          return !!v || _this.translate('customer_insights.rules.organization');
        }],
        tipo_reporte: [function (v) {
          return !!v || _this.translate('customer_insights.rules.tipo_reporte');
        }],
        brand: [function (v) {
          return !!v || _this.translate('customer_insights.rules.brand');
        }],
        indicator: [function (v) {
          return !!v || _this.translate('customer_insights.rules.indicator');
        }]
      }
    };
  },
  methods: {
    getDataEntry: function getDataEntry() {
      var _this2 = this;
      if (this.region_id.length === 0) {
        this.region_id = ['0'];
      }
      var indicatorSelected = this.indicatorsList.find(function (e) {
        return e.id_indicator === _this2.indicator_id;
      });
      this.format_cells = indicatorSelected.id_format;
      Somos1DataEntryService.getDataEntryCustomList(this.organization_id, this.brand_id, this.indicator_id, this.region_id).then(function (response) {
        if (response && response.data) {
          _this2.items = response.data;
        }
      });
    },
    getBudget: function getBudget(id_projection_category) {
      var _this3 = this;
      if (this.region_id.length === 0) {
        this.region_id = ['0'];
      }
      var indicatorSelected = this.indicatorsList.find(function (e) {
        return e.id_indicator === _this3.indicator_id;
      });
      this.format_cells = indicatorSelected.id_format;
      Somos1DataEntryService.getBudgetCustomList(this.organization_id, this.brand_id, this.indicator_id, this.region_id, id_projection_category).then(function (response) {
        if (response && response.data) {
          _this3.items = response.data;
        }
      });
    },
    getOrganizations: function getOrganizations() {
      var _this4 = this;
      if (this.isAdmin) {
        Somos1DataEntryService.getOrganizationsList().then(function (response) {
          if (response && response.data) {
            _this4.organizationsList = response.data;
          }
        });
      } else if (this.INLEARNING_DOMAIN === this.getDomainUser()) {
        Somos1DataEntryService.getOrganizationsList().then(function (response) {
          _this4.organizationsList = response.data.filter(function (item) {
            return item.company_code === '064' || item.company_code === '041' || item.company_code === '058';
          });
        });
      } else if (this.INRETAILPHARMA_DOMAIN === this.getDomainUser()) {
        Somos1DataEntryService.getOrganizationsList().then(function (response) {
          _this4.organizationsList = response.data.filter(function (item) {
            return item.company_code === '074' || item.company_code === '044';
          });
        });
      } else {
        Somos1DataEntryService.getOrganization().then(function (response) {
          _this4.organizationsList.push({
            id_organization: response.data.id_organization,
            name: response.data.name
          });
          _this4.organization_id = response.data.id_organization;
          _this4.changeOrganization();
        });
      }
    },
    getRegions: function getRegions() {
      var _this5 = this;
      Somos1DataEntryService.getRegionsList().then(function (response) {
        if (response && response.data) {
          console.log('response region');
          console.log(response);
          _this5.regionsList = response.data;
        }
      });
    },
    getBrands: function getBrands() {
      var _this6 = this;
      Somos1DataEntryService.getBrandsList(this.organization_id).then(function (response) {
        if (response && response.data) {
          console.log('response organizations');
          console.log(response);
          _this6.brandsList = response.data;
        }
      });
    },
    getIndicatorsDataEntry: function getIndicatorsDataEntry() {
      var _this7 = this;
      if (this.tipo_reporte_id === 1) {
        Somos1DataEntryService.getIndicatorsByOrganizationBrandList(this.organization_id, this.brand_id).then(function (response) {
          if (response && response.data) {
            console.log('response indicators');
            console.log(response);
            if (response.data.length > 1) {
              _this7.indicatorsList = response.data;
            }
          }
        });
      } else {
        Somos1DataEntryService.getBudgetIndicatorsByOrganizationBrandList(this.organization_id, this.brand_id).then(function (response) {
          if (response && response.data) {
            console.log('response indicators');
            console.log(response);
            if (response.data.length > 1) {
              _this7.indicatorsList = response.data;
            }
          }
        });
      }
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    changeTipoReporte: function changeTipoReporte() {
      if (this.filtro.isGeneral) {
        this.getIndicatorsDataEntry();
      } else {
        this.getBrands();
        this.brand_id = 0;
        this.indicatorsList = [];
        this.indicator_id = 0;
      }
    },
    changeOrganization: function changeOrganization() {
      if (this.filtro.isGeneral) {
        this.getIndicatorsDataEntry();
      } else {
        this.getBrands();
        this.brand_id = 0;
        this.indicatorsList = [];
        this.indicator_id = 0;
      }
    },
    changeSwitch: function changeSwitch() {
      if (this.filtro.isGeneral) {
        if (this.organization_id > 0) {
          this.brand_id = 0;
          this.getIndicatorsDataEntry();
        }
      } else {
        this.indicatorsList = [];
        this.indicator_id = 0;
        if (this.organization_id > 0) {
          this.getBrands();
        }
      }
    },
    changeBrand: function changeBrand() {
      this.getIndicatorsDataEntry();
    },
    formatExample: function formatExample(value) {
      if (value) {
        if (this.format_cells === 2) {
          return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        } else {
          return parseFloat(value * 100).toFixed(0) + '%';
        }
      }
    },
    download: function download() {
      var _this8 = this;
      this.loading = true;
      Somos1DataEntryService.postDownloadData().then(function (response) {
        if (response) {
          var url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          }));
          var link = document.createElement('a');
          link.href = url;
          var today = new Date();
          var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          var time = today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds();
          var filename = 'dataentry-' + date + '-' + time + '.xlsx';
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          _this8.loading = false;
        }
      });
    },
    download_log: function download_log() {
      var _this9 = this;
      this.loading_log = true;
      Somos1DataEntryService.postDownloadDataLog().then(function (response) {
        if (response) {
          var url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          }));
          var link = document.createElement('a');
          link.href = url;
          var today = new Date();
          var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          var time = today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds();
          var filename = 'dataentry-history-' + date + '-' + time + '.xlsx';
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          _this9.loading_log = false;
        }
      });
    },
    uploadKPIs: function uploadKPIs() {
      this.openDialog(this.DIALOG_DATA_ENTRY_UPLOAD);
    },
    uploadBudget: function uploadBudget() {
      this.openDialog(this.DIALOG_DATA_ENTRY_UPLOAD_BUDGET);
    },
    uploadForecast: function uploadForecast() {
      this.openDialog(this.DIALOG_DATA_ENTRY_UPLOAD_FORECAST);
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    onSearch: function onSearch() {
      if (!this.validate()) {
        return;
      }
      this.getDataEntry();
    },
    onSearchBudget: function onSearchBudget(id_projection_category) {
      if (!this.validate()) {
        return;
      }
      this.getBudget(id_projection_category);
    },
    onLimpiar: function onLimpiar() {
      this.$refs.form.resetValidation();
      this.items = [];
      this.indicator_id = 0;
      this.brand_id = 0;
      this.region_id = 0;
      this.filtro.isGeneral = false;
    },
    onCloseDialog: function onCloseDialog(modalName) {
      this.$refs[modalName].onClose();
    },
    calcPermissions: function calcPermissions() {
      console.log(this.companyCode);
      if (this.userHasRole(this.rolesINCA.INSIGHTS_SOMOS1_DATA_ENTRY_USER) && this.companyCode !== '032') {
        this.canUpload = true;
      } else {
        this.canUpload = false;
      }
      if (this.userHasRole(this.rolesINCA.INSIGHTS_ADMIN) || this.userHasRole(this.rolesINCA.INSIGHTS_SOMOS1_CORP_VIEWER)) {
        this.isAdmin = true;
      } else {
        this.isAdmin = false;
      }
    },
    handleDisabledUpdate: function handleDisabledUpdate(newValue) {
      this.disabled = newValue;
    },
    handleDisabledBudgetUpdate: function handleDisabledBudgetUpdate(newValue) {
      this.disabledBudget = newValue;
    },
    handleDisabledForecastUpdate: function handleDisabledForecastUpdate(newValue) {
      this.disabledForecast = newValue;
    },
    getDomainUser: function getDomainUser() {
      return window.userInfo.domain;
    }
  },
  beforeMount: function beforeMount() {
    this.calcPermissions();
    this.getOrganizations();
    this.getRegions();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    headers: function headers() {
      return [{
        text: this.translate('customer_insights.data_entry.header.year'),
        align: 'start',
        sortable: false,
        value: 'year'
      }, {
        text: this.translate('customer_insights.data_entry.header.january'),
        align: 'start',
        value: 'enero',
        formatter: this.formatExample
      }, {
        text: this.translate('customer_insights.data_entry.header.february'),
        align: 'start',
        value: 'febrero',
        formatter: this.formatExample
      }, {
        text: this.translate('customer_insights.data_entry.header.march'),
        align: 'start',
        value: 'marzo',
        formatter: this.formatExample
      }, {
        text: this.translate('customer_insights.data_entry.header.april'),
        align: 'start',
        value: 'abril',
        formatter: this.formatExample
      }, {
        text: this.translate('customer_insights.data_entry.header.may'),
        align: 'start',
        value: 'mayo',
        formatter: this.formatExample
      }, {
        text: this.translate('customer_insights.data_entry.header.june'),
        align: 'start',
        value: 'junio',
        formatter: this.formatExample
      }, {
        text: this.translate('customer_insights.data_entry.header.july'),
        align: 'start',
        value: 'julio',
        formatter: this.formatExample
      }, {
        text: this.translate('customer_insights.data_entry.header.august'),
        align: 'start',
        value: 'agosto',
        formatter: this.formatExample
      }, {
        text: this.translate('customer_insights.data_entry.header.september'),
        align: 'start',
        value: 'setiembre',
        formatter: this.formatExample
      }, {
        text: this.translate('customer_insights.data_entry.header.october'),
        align: 'start',
        value: 'octubre',
        formatter: this.formatExample
      }, {
        text: this.translate('customer_insights.data_entry.header.november'),
        align: 'start',
        value: 'noviembre',
        formatter: this.formatExample
      }, {
        text: this.translate('customer_insights.data_entry.header.december'),
        align: 'start',
        value: 'diciembre',
        formatter: this.formatExample
      }, {
        text: '',
        align: 'end',
        value: 'actions'
      }];
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('menu.customer.home'),
        disabled: false,
        href: '/#/customer_insights/home'
      }, {
        text: this.translate('menu.customer.somos1'),
        disabled: false,
        href: '/#/customer_insights/somos1_home'
      }, {
        text: 'dataentry',
        disabled: true,
        href: ''
      }];
    }
  })
};